import PropTypes from 'prop-types';
import { PanelLeft, PanelLeftClose } from 'lucide-react';
import { cn } from '../../lib/cn';
import { useSidebarCollapseOptional } from '../../context/SidebarCollapseContext';

/**
 * RFID-style sidebar collapse control (PanelLeft / PanelLeftClose).
 * variant="header" — white topbar; variant="footer" — black rail footer.
 */
export default function SidebarCollapseButton({
  variant = 'header',
  className,
}) {
  const drawer = useSidebarCollapseOptional();
  if (!drawer) return null;

  const { sidebarCollapsed: collapsed, toggleSidebarCollapsed } = drawer;
  const label = collapsed ? 'Expand sidebar' : 'Collapse sidebar';

  return (
    <button
      type="button"
      className={cn(
        variant === 'footer'
          ? 'leap-sidebar-collapse-btn'
          : 'leap-header-collapse-btn',
        className
      )}
      onClick={toggleSidebarCollapsed}
      title={label}
      aria-label={label}
      aria-expanded={!collapsed}
    >
      {collapsed ? (
        <PanelLeft size={variant === 'footer' ? 16 : 20} strokeWidth={2.5} />
      ) : (
        <PanelLeftClose size={variant === 'footer' ? 16 : 20} strokeWidth={2.5} />
      )}
      {variant === 'footer' && !collapsed ? (
        <span>Collapse</span>
      ) : null}
    </button>
  );
}

SidebarCollapseButton.propTypes = {
  variant: PropTypes.oneOf(['header', 'footer']),
  className: PropTypes.string,
};
